// @flow
import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

const propTypes = {
  children: PropTypes.any
};
const defaultProps = {};

const StyledButtonGroup = styled.div`
  display: flex;

  button {
    &:not(:first-child):not(:last-child) {
      border-radius: 0;
    }

    &:first-child {
      border-bottom-right-radius: 0;
      border-top-right-radius: 0;
    }

    &:last-child {
      border-bottom-left-radius: 0;
      border-top-left-radius: 0;
    }
  }
`;

const ButtonGroup = (props) => {
  const { children, ...rest} = props;
  return (
    <StyledButtonGroup {...rest}>
      {children}
    </StyledButtonGroup>
  );
};

ButtonGroup.propTypes = propTypes;
ButtonGroup.defaultProps = defaultProps;

export default ButtonGroup;



// WEBPACK FOOTER //
// ./src/modules/common/components/button/ButtonGroup.js